import openDatabase from "../../IndexedDB/openDatabase";
const storeListUIStateInIndexedDB = async (
  persistKey,
  stateToSave,
  dbName = "ERP_DB",
  storeName = "List_Ui_State",
  dbVersion = 1,
) => {
  try {
    // Open or create the database and object store
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Ensure that the store is available
    if (!db.objectStoreNames.contains(storeName)) {
      throw new Error(`Object store '${storeName}' does not exist in the database`);
    }

    // Start a readwrite transaction
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    return new Promise((resolve, reject) => {
      const getRequest = store.get(persistKey);
      getRequest.onsuccess = () => {
        const existing = getRequest.result || {};

        const mergedState = {
          ...existing,
          ...stateToSave,
        };

        const putRequest = store.put(mergedState, persistKey);

        putRequest.onsuccess = () => resolve();
        putRequest.onerror = (err) => reject(err);
      };

      getRequest.onerror = (err) => reject(err);
    });

    // console.log("List_Ui_State stored successfully");
  } catch (error) {
    console.error("Error storing List UI State:", error);
  }
};
export default storeListUIStateInIndexedDB;
